// @flow
import { connect } from 'react-redux'
import PreviewImageCropper from './PreviewImageCropper'
import { getMedia } from '../../redux/selectors'
import type { Store } from '../../redux/ducks'
import _ from 'lodash'

function mapStateToProps(state: Store, ownProps: Object) {
  return { image: getMedia(state, ownProps.imageStoreId) }
}

const PreviewImageCropperContainer = connect<Object, Object, _, _, _, _>(mapStateToProps)(
  PreviewImageCropper
)

export default PreviewImageCropperContainer
